module.exports = {
      id: "icon-double-tick-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-double-tick",
      toString: function () {
        return this.url;
      }
    }